<template>
    <div class="chance">
      <div class="banner-top">
        <div class="banner-box"></div>
        <div class="banner-desc">从必读资讯到深度研究，从超短狙击到政策前瞻——机会与风险并存，风险与机会并重</div>
      </div>
      <div class="chance-box">
        <el-row :gutter="20">
            <el-col :span="8" v-for="(item, i) in menuList" :key="i">
              <el-tooltip class="item" effect="light" :content="item.desc" placement="bottom" popper-class="third-tooltip">
              <div class="grid-content bg-purple cursorPointer" @click="token && selectMenu(i)">
                <div :class="currentIndex === i ? 'active' : ''"><img class="small-img" :src="currentIndex === i ? item.imgUrl : item.imgUrls" alt="">{{item.txt}}</div>
              </div>
              </el-tooltip>
            </el-col>
        </el-row>

        <div class="list" v-show="currentIndex === ''">
          <div class="list-box" v-for="(item,i) in itemList" :key="i">
            <div class="img-box">
              <img class="thumb-img" :src="item.img" alt="">
            </div>
            <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=chance'">
              <div class="article_title">
                <div class="title">{{ item.title }}</div>
                <div class="list-content">{{ item.desc }}</div>
                <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
              </div>
            </a>
          </div>
          <div class="more">
            <div class="cursorPointer">
              <div @click="getMore">点击加载更多...</div>
            </div>
          </div>
        </div>


        <div class="article-list" v-show="currentIndex === 0">
          <div class="zx-list">
            <el-tabs v-model="activeBdName" type="card" @tab-click="handleClick">
              <el-tab-pane label="最新" name="first">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item,i) in itemLatestList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=chance'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom">
                            {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="recommendList">
                          <li v-for="(item, i) in itemTjList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=chance'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getLatestMore();getLatestTjMore()">点击加载更多...</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="早安谍报" name="second">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item, i) in itemPzList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=chance'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom">
                            {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="sx-recommendList">
                          <li v-for="(item, i) in itemPzTjList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=chance'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getDbMore();getDbTjMore()">点击加载更多...</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="盘前点金" name="third">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item, i) in itemHqList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=chance'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom">
                            {{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="zq-recommendList">
                          <li v-for="(item, i) in itemHqTjList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=chance'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getDjMore();getDjTjMore()">点击加载更多...</div>
                  </div>
                </div>

              </el-tab-pane>
              <el-tab-pane label="题材挖掘" name="fourth">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item, i) in itemXjList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=chance'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom">
                            {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="yp-recommendList">
                          <li v-for="(item, i) in itemXjTjList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=chance'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getTcMore();getTcTjMore()">点击加载更多...</div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>

          </div>
        </div>


        <div class="article-list" v-show="currentIndex === 1">
          <div class="zx-lists">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
              <el-tab-pane label="政策" name="five">
                <el-table
                  :data="tableData"
                  style="width: 100%">
                  <el-table-column
                    prop="spdate"
                    label="时间"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="subject"
                    label="主体"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="policy"
                    label="政策">
                  </el-table-column>
                  <el-table-column
                    prop="content"
                    label="内容"
                    >
                    <template slot-scope="scope">
                      <!-- tips悬浮提示 -->
                      <el-tooltip
                        placement="top"
                        popper-class="tip-box"
                        v-model="scope.row.showTooltip"
                        :open-delay="500"
                        effect="light"
                        :disabled="!scope.row.showTooltip">
                        <div slot="content" class="tip-box">{{scope.row.content}}</div>
                        <div @mouseenter="showTips($event,scope.row)" class='myNote'>{{scope.row.content}}</div>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="importancelevel"
                    label="重要性"
                    :formatter="importanceLevel"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="theme"
                    label="相关概念"
                    width="180">
                  </el-table-column>
                </el-table>
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="pageSizes"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalCount">
                </el-pagination>
              </el-tab-pane>
              <el-tab-pane label="事件" name="six">
                <el-table
                :data="tableSjData"
                style="width: 100%">
                <el-table-column
                  prop="spdate"
                  label="时间"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="subject"
                  label="主体"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="investment"
                  label="事件">
                </el-table-column>
                <el-table-column
                  prop="content"
                  label="内容">
                  <template slot-scope="scope">
                    <!-- tips悬浮提示 -->
                    <el-tooltip
                      placement="top"
                      popper-class="tip-box"
                      v-model="scope.row.showTooltip"
                      :open-delay="500"
                      effect="light"
                      :disabled="!scope.row.showTooltip">
                      <div slot="content" class="tip-box">{{scope.row.content}}</div>
                      <div @mouseenter="showTips($event,scope.row)" class='myNote'>{{scope.row.content}}</div>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="importancelevel"
                  label="重要性"
                  :formatter="importanceLevel"
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="theme"
                  label="相关概念"
                  width="180">
                </el-table-column>
              </el-table>
                <el-pagination
                  @size-change="handleSizeInvestChange"
                  @current-change="handleCurrentInvestChange"
                  :current-page="currentPage"
                  :page-sizes="pageSizes"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalSjCount">
                </el-pagination>
              </el-tab-pane>
              <el-tab-pane label="数据" name="seven">
                <el-table
                  :data="tableDataData"
                  style="width: 100%">
                  <el-table-column
                    prop="date"
                    label="日期"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="hours"
                    label="时间"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="area"
                    label="地区"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="content"
                    label="事件">
                  </el-table-column>
                  <el-table-column
                    prop="importancelevel"
                    :formatter="importanceLevel"
                    label="重要性">
                  </el-table-column>
                  <el-table-column
                    prop="curvalue"
                    label="今值">
                  </el-table-column>
                  <el-table-column
                    prop="expvalue"
                    label="预期">
                  </el-table-column>
                  <el-table-column
                    prop="prevalue"
                    label="前值">
                  </el-table-column>
                </el-table>
                <el-pagination
                  @size-change="handleSizeRlChange"
                  @current-change="handleCurrentRlChange"
                  :current-page="currentRlPage"
                  :page-sizes="pageSizes"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalDataCount">
                </el-pagination>
              </el-tab-pane>
              <el-tab-pane label="潜伏" name="eight">
                <el-table
                  :data="tableOppData"
                  style="width: 100%">
                  <el-table-column
                    prop="spdate"
                    label="节点时间"
                    width="160">
                  </el-table-column>
                  <el-table-column
                    prop="event"
                    label="事件"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="content"
                    label="内容">
                    <template slot-scope="scope">
                      <!-- tips悬浮提示 -->
                      <el-tooltip
                        placement="top"
                        popper-class="tip-box"
                        v-model="scope.row.showTooltip"
                        :open-delay="500"
                        effect="light"
                        :disabled="!scope.row.showTooltip">
                        <div slot="content" class="tip-box">{{scope.row.content}}</div>
                        <div @mouseenter="showTips($event,scope.row)" class='myNote'>{{scope.row.content}}</div>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="importancelevel"
                    label="可信度"
                    :formatter="importanceLevel"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="theme"
                    label="题材"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="stock"
                    label="关联龙头"
                    width="180">
                  </el-table-column>
                </el-table>
                <el-pagination
                  @size-change="handleSizeOppChange"
                  @current-change="handleCurrentOppChange"
                  :current-page="currentPage"
                  :page-sizes="pageSizes"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalOppCount">
                </el-pagination>
              </el-tab-pane>
              <el-tab-pane label="风险" name="nine">
                <el-table
                  :data="tableRiskData"
                  style="width: 100%">
                  <el-table-column
                    prop="datetimelevel"
                    label="时间"
                    :formatter="datetimeLevel"
                    width="60">
                  </el-table-column>
                  <el-table-column
                    prop="riskconcern"
                    label="风险关注"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="pubsentiment"
                    label="舆情"
                    >
                    <template slot-scope="scope">
                      <!-- tips悬浮提示 -->
                      <el-tooltip
                        placement="bottom"
                        popper-class="tip-box"
                        v-model="scope.row.showTooltip"
                        :open-delay="500"
                        effect="light"
                        :disabled="!scope.row.showTooltip">
                        <div slot="content" class="tip-box">{{scope.row.pubsentiment}}</div>
                        <div @mouseenter="showTipsYq($event,scope.row)" class='myNote'>{{scope.row.pubsentiment}}</div>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="comment"
                    label="点评">
                    <template slot-scope="scope">
                      <!-- tips悬浮提示 -->
                      <el-tooltip
                        placement="top"
                        popper-class="tip-box"
                        v-model="scope.row.showTooltip"
                        :open-delay="500"
                        effect="light"
                        :disabled="!scope.row.showTooltip">
                        <div slot="content" class="tip-box">{{scope.row.comment}}</div>
                        <div @mouseenter="showTipsRisk($event,scope.row)" class='myNote'>{{scope.row.comment}}</div>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="risklevel"
                    label="风险级别"
                    :formatter="importanceLevel"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="spreadlevel"
                    label="扩散周期"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    label="传导逻辑"
                    width="120">
                    <template slot-scope="scope">
                      <el-image :src="scope.row.transmit_img" :preview-src-list="[scope.row.transmit_img]">
                        <div slot="error" class="image-slot">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="bullish"
                    label="利多"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="bearish"
                    label="利空"
                   >
                  </el-table-column>
                </el-table>
                <el-pagination
                  @size-change="handleSizeRiskChange"
                  @current-change="handleCurrentRiskChange"
                  :current-page="currentPage"
                  :page-sizes="pageSizes"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalRiskCount">
                </el-pagination>
              </el-tab-pane>
              <el-tab-pane label="(更新频率：交易日盘前)" name="x" disabled></el-tab-pane>
            </el-tabs>
          </div>
        </div>

        <div class="list" v-show="currentIndex === 2">
          <div class="list-box" v-for="(item,i) in itemReportList" :key="i">
            <div class="img-box">
              <img class="thumb-img" :src="item.img" alt="">
            </div>
            <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=chance'">
              <div class="article_title">
                <div class="title">{{ item.title }}</div>
                <div class="list-content">{{ item.desc }}</div>
                <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
              </div>
            </a>
          </div>
          <div class="more">
            <div class="cursorPointer">
              <div @click="getReportMore">点击加载更多...</div>
            </div>
          </div>
        </div>

      </div>
      <div class="back-top" @click="backTop" v-show="btnFlag">
        <img src="../assets/images/return_top.png" alt="" srcset="">
      </div>
    </div>
</template>

<script>
import { Chance, Report, LatestList,FundTjList,PzList, PzTjList,HqList, HqTjList, XjList, XjTjList } from "@/api/news";
import { Policy, Investment, Data, Opportunity, HseCalendar } from "@/api/calendar";
export default {
  name: "Chance",
  data() {
    return {
      activeName: 'five',
      currentBdTab:'first',
      activeBdName: 'first',
      currentIndex:'',
      token: window.localStorage.getItem('token'),
      itemList: [],
      itemReportList: [],
      itemLatestList: [],
      itemTjList: [],
      itemPzList: [],
      itemPzTjList: [],
      itemHqList: [],
      itemHqTjList: [],
      itemXjList: [],
      itemXjTjList: [],
      currentPage:1,
      currentRlPage:1,
      totalCount:1,
      totalSjCount:1,
      totalOppCount:1,
      totalRiskCount:1,
      totalDataCount:1,
      pageSizes:[1,5,10,20],
      PageSize:5,
      page: 1,
      zxPage: 1,
      zxTjPage: 1,
      dbPage: 1,
      dbTjPage: 1,
      djPage: 1,
      djTjPage: 1,
      tcPage: 1,
      tcTjPage: 1,
      ybPage: 1,
      btnFlag: false,
      menuList:[
        {
          imgUrl: require('../assets/images/icon_盘前必读2.png'),
          imgUrls: require('../assets/images/icon_盘前必读1.png'),
          txt: '盘前必读',
          desc: '投资者盘前必须掌握的所有信息：谍报头条、要闻解读、主流策略、机会热点和潜力个股（更新频率：交易日盘前）'
        },
        {
          imgUrl: require('../assets/images/icon_投资日历2.png'),
          imgUrls: require('../assets/images/icon_投资日历1.png'),
          txt: '投资日历',
          desc: '国内首创将机会挖掘与风险做成深度前瞻的研究型产品。在重大政策和事件的前瞻上下苦功，预判风险和投资机会',
        },
        {
          imgUrl: require('../assets/images/icon_脱水研报2.png'),
          imgUrls: require('../assets/images/icon_脱水研报1.png'),
          txt: '脱水研报',
          desc: '大数据结合专业实力，在海量研报中挖掘最有价值的策略、题材和个股。一篇脱水提炼多篇优选研报的核心逻辑，实为干货中的干货',
        },
      ],
      tableData: [],
      tableOppData: [],
      tableSjData: [],
      tableRiskData: [],
      tableDataData: [],
    }
  },
  created() {
    this.$emit('header', true);
    this.$emit('footer', true);
    this.getAllList()
    this.getReportList()
    this.getLatestList()
    this.getTjList()
    this.getDbList()
    this.getDbTjList()
    this.getDjList()
    this.getDjTjList()
    this.getTcList()
    this.getTcTjList()
    this.getPolicyList(1)
    this.getInvestmentList(1)
    this.getDataList(1)
    this.getOpportunitymentList(1)
    this.getHseCalendarList(1)
  },
  mounted() {
    this.toJump()
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    showTips(obj, row){
      /*obj为鼠标移入时的事件对象*/

      /*currentWidth 为文本在页面中所占的宽度，创建标签，加入到页面，获取currentWidth ,最后在移除*/
      let TemporaryTag = document.createElement('span');
      TemporaryTag.innerText = row.content;
      TemporaryTag.className = 'getTextWidth';
      document.querySelector('body').appendChild(TemporaryTag);
      let currentWidth = document.querySelector('.getTextWidth').offsetWidth;
      document.querySelector('.getTextWidth').remove();

      /*cellWidth为表格容器的宽度*/
      const cellWidth = obj.target.offsetWidth

      /*当文本宽度小于||等于容器宽度两倍时，代表文本显示未超过两行*/
      currentWidth <= (2*cellWidth) ? row.showTooltip = false : row.showTooltip = true
    },
    showTipsRisk(obj, row){
      /*obj为鼠标移入时的事件对象*/
      /*currentWidth 为文本在页面中所占的宽度，创建标签，加入到页面，获取currentWidth ,最后在移除*/
      let TemporaryTag = document.createElement('span');
      TemporaryTag.innerText = row.comment;
      TemporaryTag.className = 'getTextWidth';
      document.querySelector('body').appendChild(TemporaryTag);
      let currentWidth = document.querySelector('.getTextWidth').offsetWidth;
      document.querySelector('.getTextWidth').remove();

      /*cellWidth为表格容器的宽度*/
      const cellWidth = obj.target.offsetWidth

      /*当文本宽度小于||等于容器宽度两倍时，代表文本显示未超过两行*/
      currentWidth <= (2*cellWidth) ? row.showTooltip = false : row.showTooltip = true
    },
    showTipsYq(obj, row){
      /*obj为鼠标移入时的事件对象*/
      /*currentWidth 为文本在页面中所占的宽度，创建标签，加入到页面，获取currentWidth ,最后在移除*/
      let TemporaryTag = document.createElement('span');
      TemporaryTag.innerText = row.pubsentiment;
      TemporaryTag.className = 'getTextWidth';
      document.querySelector('body').appendChild(TemporaryTag);
      let currentWidth = document.querySelector('.getTextWidth').offsetWidth;
      document.querySelector('.getTextWidth').remove();

      /*cellWidth为表格容器的宽度*/
      const cellWidth = obj.target.offsetWidth

      /*当文本宽度小于||等于容器宽度两倍时，代表文本显示未超过两行*/
      currentWidth <= (2*cellWidth) ? row.showTooltip = false : row.showTooltip = true
    },
    importanceLevel: function (row, column, cellValue){
      switch(cellValue) {
        case 1:
          return '★'
          break;
        case 2:
          return '★★'
          break;
        case 3:
          return '★★★'
          break;
        case 4:
          return '★★★★'
          break;
        case 5:
          return '★★★★★'
          break;
      }
    },
    datetimeLevel: function (row, column, cellValue){
      switch(cellValue) {
        case 1:
          return '年头'
          break;
        case 2:
          return '年中'
          break;
        case 3:
          return '年尾'
          break;
      }
    },
    toJump(){
      if(this.$route.query.activeName!=null){
        this.activeBdName = this.$route.query.activeName;
        this.currentBdTab = this.$route.query.currentTab;
        const currentBd = this.currentBdTab;
        // console.log(currentBd);
        if(currentBd ==='first' || currentBd ==='second' || currentBd === 'third' || currentBd === 'fourth'){
          this.currentIndex = 0
        }else if(currentBd === 'five'){
          this.currentIndex = 1
        }else if(currentBd === 'six'){
          this.currentIndex = 2
        }
      }
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.PageSize = val;
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getPolicyList(val);
    },
    handleSizeInvestChange(val) {
      // console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.PageSize = val;
    },
    handleCurrentInvestChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getInvestmentList(val);
    },
    handleSizeRlChange(val) {
      // console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.PageSize = val;
    },
    handleCurrentRlChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getDataList(val);
    },
    handleSizeOppChange(val) {
      // console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.PageSize = val;
    },
    handleCurrentOppChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getOpportunitymentList(val);
    },
    handleSizeRiskChange(val) {
      // console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.PageSize = val;
    },
    handleCurrentRiskChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getHseCalendarList(val);
    },
    handleClick(tab, event) {
      // console.log(tab, event);
      const updateTime = {
        "政策": "(更新频率：交易日盘前)",
        "事件": "(更新频率：至少一次/周)",
        "数据": "(更新频率：至少一次/周)",
        "潜伏": "(更新频率：至少一次/周)",
        "风险": "(更新频率：至少一次/周)",
      };
      if (tab.name == 'five' || tab.name == 'six' || tab.name == 'seven') {
        let txt = tab.label
        $("#tab-x").text(updateTime[txt]);
      } else if( tab.name == 'eight' || tab.name == 'nine' ) {
        let txt = tab.label
        $("#tab-x").text(updateTime[txt]);
      } else{
        $("#tab-x").text('(更新频率：交易日盘前)');
      }
    },
    selectMenu(index) {
      this.currentIndex = index
    },
    backTop() {
      const that = this
      let timer = setInterval(() => {
        let isPeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + isPeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16);
    },
    scrollToTop() {
      const that = this
      that.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },
    getAllList() {
      Chance({id: '5q6gxyiwyz', page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 403 || response.code === 505) {
          this.itemList = this.itemList.concat(response.data.data)
        }
      });
    },
    getReportList() {
      Report({id: 'zk83q805xs', page: this.ybPage}).then((response) => {
        if (response.code === 2000 || response.code === 403 || response.code === 505) {
          this.itemReportList = this.itemReportList.concat(response.data.data)
        }
      });
    },
    getLatestList() {
      LatestList({id: '1wn8uf3cznn', page: this.zxPage}).then((response) => {
        if (response.code === 2000 || response.code === 403 || response.code === 505) {
          this.itemLatestList = this.itemLatestList.concat(response.data.data)
        }
      });
    },
    getDbList() {
      PzList({id: '1m7i953rwib', page: this.dbPage}).then((response) => {
        if (response.code === 2000 || response.code === 403 || response.code === 505) {
          this.itemPzList = this.itemPzList.concat(response.data.data)
        }
      });
    },
    getDjList() {
      HqList({id: '2l9f6kbbjmq', page: this.djPage}).then((response) => {
        if (response.code === 2000 || response.code === 403 || response.code === 505) {
          this.itemHqList = this.itemHqList.concat(response.data.data)
        }
      });
    },
    getTcList() {
      XjList({id: 'x75h90npjh', page: this.tcPage}).then((response) => {
        if (response.code === 2000 || response.code === 403 || response.code === 505) {
          this.itemXjList = this.itemXjList.concat(response.data.data)
        }
      });
    },
    getPolicyList(n1) {
      Policy({ name: 'policy',page:n1,limit:10}).then((response) => {
        if (response.code === 2000 || response.code === 403 || response.code === 505) {
          this.tableData = response.data.data
          this.currentPage = n1
          this.PageSize = response.data.limit
          this.totalCount = response.data.total
        }
      });
    },
    getInvestmentList(n2) {
      Investment({ name: 'investment',page:n2,limit:10}).then((response) => {
        if (response.code === 2000 || response.code === 403 || response.code === 505) {
          this.tableSjData = response.data.data
          this.currentPage = n2
          this.PageSize = response.data.limit
          this.totalSjCount = response.data.total
        }
      });
    },
    getDataList(n5) {
      Data({ name: 'data',page:n5,limit:10}).then((response) => {
        if (response.code === 2000 || response.code === 403 || response.code === 505) {
          this.tableDataData = response.data.data
          this.currentPage = n5
          this.PageSize = response.data.limit
          this.totalDataCount = response.data.total
        }
      });
    },
    getOpportunitymentList(n3) {
      Opportunity({ name: 'opportunity',page:n3,limit:10}).then((response) => {
        if (response.code === 2000 || response.code === 403 || response.code === 505) {
          this.tableOppData = response.data.data
          this.currentPage = n3
          this.PageSize = response.data.limit
          this.totalOppCount = response.data.total
        }
      });
    },
    getHseCalendarList(n4) {
      HseCalendar({ name: 'hseCalendar',page:n4,limit:10}).then((response) => {
        if (response.code === 2000 || response.code === 403 || response.code === 505) {
          this.tableRiskData = response.data.data
          this.currentPage = n4
          this.PageSize = response.data.limit
          this.totalRiskCount = response.data.total
        }
      });
    },
    getTjList() {
      FundTjList({id:'2bwoal5oysw',limit: 3, page: this.zxTjPage}).then((response) => {
        if (response.code === 2000 || response.code === 403 || response.code === 505) {
          this.itemTjList = this.itemTjList.concat(response.data.data)
        }
      });
    },
    getDbTjList() {
      PzTjList({id:'2bwoal5oysw',limit: 3, page: this.dbTjPage}).then((response) => {
        if (response.code === 2000 || response.code === 403 || response.code === 505) {
          this.itemPzTjList = this.itemPzTjList.concat(response.data.data)
        }
      });
    },
    getDjTjList() {
      HqTjList({id:'2bwoal5oysw',limit: 3, page: this.djTjPage}).then((response) => {
        if (response.code === 2000 || response.code === 403 || response.code === 505) {
          this.itemHqTjList = this.itemHqTjList.concat(response.data.data)
        }
      });
    },
    getTcTjList() {
      XjTjList({id:'2bwoal5oysw',limit: 3, page: this.tcTjPage}).then((response) => {
        if (response.code === 2000 || response.code === 403 || response.code === 505) {
          this.itemXjTjList = this.itemXjTjList.concat(response.data.data)
        }
      });
    },
    getMore() {
      this.page++;
      this.getAllList()
    },
    getLatestMore() {
      this.zxPage++;
      this.getLatestList()
    },
    getLatestTjMore() {
      this.zxTjPage++;
      this.getTjList()
    },
    getReportMore() {
      this.ybPage++;
      this.getReportList()
    },
    getDbMore() {
      this.dbPage++;
      this.getDbList()
    },
    getDbTjMore() {
      this.dbTjPage++;
      this.getDbTjList()
    },
    getDjMore() {
      this.djPage++;
      this.getDjList()
    },
    getDjTjMore() {
      this.djTjPage++;
      this.getDjTjList()
    },
    getTcMore() {
      this.tcPage++;
      this.getTcList()
    },
    getTcTjMore() {
      this.tcTjPage++;
      this.getTcTjList()
    },
  }
}
</script>

<style scoped>
>>>#tab-nine{
  display: none;
}
.chance {
  background-color: #F5F7FA;
}
.chance-box {
  width: 1200px;
  margin: -30px auto 0;
}

.active{
  color: #ffe400;
}
.banner-top {
  width: 100%;
  height: 100px;
  margin-top: 50px;
  line-height: 70px;
  background: url("../assets/images/banner_top.png") no-repeat center / cover;
}
.banner-box {
  width: 1200px;
  margin: 0 auto;
}
.banner-desc {
  text-align: center;
  font-size: 14px;
  color: #FFFFFF;
}

.banner-desc {
  text-align: center;
  font-size: 14px;
  color: #FFFFFF;
}

.bg-purple {
  background: #d3dce6;
}

.grid-content {
  height: 60px;
  color: white;
  background-image: linear-gradient(#0c255c, #040f27);
  line-height: 60px;
  font-size: 16px;
  padding-left: 50px;
}

.cursorPointer {
  cursor: pointer;
}

.small-img {
  height: 30px;
  padding-right: 20px;
  vertical-align: middle;
}

.list {
  margin: 10px 0;
}

.list-box {
  display: flex;
  background-color: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  height: 120px;
  padding: 10px 20px;
}


.img-box {
  margin-right: 40px;
}

.thumb-img {
  width: 240px;
  height: 120px;
  flex: 0 0 240px;
}

.list-title {
  position: relative;
}

.title {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #313131;
}

.list-content {
  font-size: 14px;
  line-height: 28px;
  color: #898989;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.list-bottom {
  font-size: 14px;
  bottom: 0;
  min-width: 860px;
  color: #898989;
  position: absolute;
  pointer-events: none;
}

.zx-list {
  width: 1200px;
  margin-top: 10px;
  display: flex;
}

.main-content{
  display: flex;
  width: 1200px;
}

.zx-list .left {
  width: 900px;
  margin-right: 10px;
}

.zx-list .right {
  width: 300px;
  margin-top: -44px;
}

.zx-list .right .recommend .recommend-list {
  padding: 30px 0;
  background: #fff;
  margin-top: 14px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}

.zx-list .right .recommend .recommend-list ul {
  width: 260px;
  margin: 0 auto;
}

.zx-list .right .recommend .recommend-list li:not(:last-child) {
  border-bottom: 1px solid #cdcdcd;
  margin-bottom: 30px;
}

.zx-list .right .recommend .recommend-list li img {
  width: 260px;
  height: 120px;
  margin: 0 auto;
}

.zx-list .right .recommend .recommend-list li .recommend-title {
  margin: 15px 0;
  font-size: 14px;
  color: #313131;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.zx-list .right .recommend .top .title {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #FFFFFF;
  background-image: linear-gradient(#0c255c, #040f27);
}

.zx-list .right .recommend .recommend-list li .recommend-bottom {
  font-size: 12px;
  color: #898989;
  margin-bottom: 23px;
}

.zx-lists {
  width: 1200px;
  margin-top: 10px;
  padding-bottom: 20px;
}

>>> .el-tabs__item {
  width: 160px;
  text-align: center;
  color: #313131;
  background-color: #FFFFFF;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
}

>>> .is-active {
  color: #FFFFFF;
  height: 30px;
  background-image: linear-gradient(#0c255c, #040f27);
}

>>> .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__item {
  border: 1px solid #E4E7ED;
  margin-right: 10px;
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}

>>>#tab-x{
  border: none;
  background-color: transparent;
  text-align: right;
  font-size: 12px;
}

.more {
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin: 10px 0;
  font-size: 12px;
  color: #a0a8b0;
  text-align: center;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.back-top {
  position: fixed;
  right: 40px;
  bottom: 40px;
  cursor: pointer;
  z-index: 9999;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Chance.vue